// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"281":"alias","596":"404","760":"card","818":"auth","963":"send"}[chunkId] + "." + {"281":"e736ee7b","596":"1ca66801","760":"52dae22c","818":"f656fd50","963":"bb425c97"}[chunkId] + ".js";
};